import { getContainer } from '../ioc/IOCSetup';

export const useGlifeOneTimeToken = () => {
	const userService = getContainer().getUserService();

    const getOneTimeToken = async () => {
        try {
            const response = await userService.getOneTimeToken();
            return response.token
        } catch (err) {
            return err;
        }
    };

    const authenticateWithOneTimeToken = async (token: string) => {
        try {
            const response = await userService.authenticeWithOneTimeToken(token);
            return response;
        } catch (err) {
            return err;
        }
    };

    return {
        getOneTimeToken,
        authenticateWithOneTimeToken,
    };
};
